module.exports = __webpack_public_path__ + "img/02.3020aa25.png";